<template>
	<div class="settings">
		<div class="row mb-8">
			<div class="col-6">
				<h1>{{ $t('editor') }}</h1>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<div class="list-group border-radius-2 no-border mb-3">
					<router-link to="/formeditor/forms" class="list-group-item">{{ $t('forms') }}</router-link>
					<router-link to="/formeditor/formtypes" class="list-group-item">{{ $t('form-types') }}</router-link>
					<router-link to="/formeditor/formlibrary/field" class="list-group-item">{{ $t('form-library-fields') }}</router-link>
					<router-link to="/formeditor/formlibrary/selectoptions" class="list-group-item">{{ $t('form-library-options') }}</router-link>
					<router-link to="/formeditor/questionbank" class="list-group-item">{{ $t('question-bank') }}</router-link>
					<router-link to="/formeditor/responsevaluegroups" class="list-group-item">{{ $t('response-value-groups') }}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	data: function() {
		return {
		};
	},
	mounted() {
	},
	methods: {
	}
};
</script>
